import React, { useState, useContext, useEffect, useRef } from 'react';
import { Redirect, Route, useHistory } from 'react-router-dom';
import { IonApp, IonRouterOutlet, IonSplitPane, IonTabs, IonTabBar, IonTabButton, IonContent,IonLabel, IonGrid, IonItem, IonPage} from '@ionic/react';

import { IonInput, IonButton, IonRow, IonCol } from '@ionic/react';

import { NativeBiometric } from "capacitor-native-biometric";
import { BiometryType } from "capacitor-native-biometric";
import { Preferences } from '@capacitor/preferences';


//import { Plugins } from '@capacitor/core';
import { PrivateRoute_Zasava } from './components/PrivateRoute_Zasava';

import { ZsavaHome } from './pages/public/views/ZsavaHome';

import {ConfirmMerchantLogout} from './pages/public/components/MerchantLogout';

import {  SideMenu } from './components/SideMenu';
import HomePage_Admin from './pages/internal/views/HomePage_Admin';
import Zasava_ProfileSetting from './pages/internal/views/zasava_profileSetting';
import Zasava_AccountSetting from './pages/internal/views/zasava_accountSetting';

import Zasava_PrivacyStatement from './pages/public/components/PrivacyStatement_static';
import Contact_Us from './pages/public/components/Zasava_Contact_Us';


import { Auth_Zasava_Context } from './storeState/Auth_Zasava_Context';

import { ZasavaLoginCredentials } from './pages/public/components/ZasavaLoginCredentials';

import {Applicant_OfferLetterModal} from './pages/internal/components/Modal_Applicant_OfferLetter';

import {Push_Notification} from './pages/internal/components/PushNotifictions';

import './pages/css/layout.css';


import Cookie from 'universal-cookie';


let cookies = new Cookie();


async function removeStorageCredentials() {


    await Preferences.remove({ key: 'accountID' });
    await Preferences.remove({ key: 'employeeID' });
    await Preferences.remove({ key: 'employee_first_name' });
    await Preferences.remove({ key: 'employee_last_name' });
    await Preferences.remove({ key: 'employee_company' });
    await Preferences.remove({ key: 'employee_createdBy' });
    await Preferences.remove({ key: 'schemaName' });
    await Preferences.remove({ key: 'isAuthenticated' });
    await Preferences.remove({ key: 'accessRights' });
    await Preferences.remove({ key: 'loginUsername_authenticated' });
    await Preferences.remove({ key: 'loginPassword_authenticated' });
    await Preferences.remove({ key: 'isBiometricFingerprintAvilable' });
    await Preferences.remove({ key: 'biometricFingerprint' });
    await Preferences.remove({ key: 'device' });
    await Preferences.remove({ key: 'sessionID' });
    await Preferences.remove({ key: 'baseURL' });
    await Preferences.remove({ key: 'capability' });
    await Preferences.remove({ key: 'feature' });

    let remove_cookie = null;

    cookies.remove('session', remove_cookie);


}

function setStorageCredentials_sessionID(event) {

    //alert('In setStorageCredentials_sessionID');
    //alert(event);

    Preferences.set({
        key: 'sessionID',
        value: event,
    })
}

async function setAppDevice_device(event) {

    Preferences.set({
        key: 'device',
        value: event,
    })
    
}

async function setAppDevice_url(event) {

    Preferences.set({
        key: 'baseURL',
        value: event,
    })
    
}



//class App extends React.Component   {
//const App: React.FC<AppProps> = (props: any) => {
export function App () {

    //alert("IN APP");

    let authenticatedMerchent_context = useContext(Auth_Zasava_Context);

    let [homeView, setHomeView] = useState('0');
    let [isBiometric_fingerprintAvailable, setIsBiometric_fingerprintAvailable ] = useState(authenticatedMerchent_context.isBiometric_fingerprintAvailable);
    let [biometric_fingerprint, setBiometric_fingerprint] = useState(authenticatedMerchent_context.biometric_fingerprint);
    let [device, setDevice ] = useState(authenticatedMerchent_context.device);
    let [entryPaths, setEntryPaths] = useState([
        '/', '/hotel_merchantMainPageApp', '/hotel_merchantMainPageApp/overviewTab', '/hotel_merchantMainPageApp/checkIn_checkOutTab',
        '/hotel_merchantMainPageApp/cleaningServicesTab', '/hotel_merchantMainPageApp/reservationsTab' 
    ]);

    let [merchantLoginModal, setMerchantLoginModal] = useState(true);
    let [fingerprintLoginModal, setFingerprintLoginModal] = useState(true);

    let [viewApplicant_OfferModal, setViewApplicant_OfferModal] = useState(false);
    let [applicant_merchantID, setAppliant_merchantID] = useState(null);
    let [applicant_requisitionID, setAppliant_requisitionID] = useState(null);
    let [applicant_applicationID, setAppliant_applicationID] = useState(null);

    let [notificationData, setNotificationData] = useState(null);

    let history = useHistory();

    //let [landingPage, setLandingPage] = useState('/home');

    
    /*let [acctID, setData_acctID] = useState<string | null>(null);
    let [employeeID, setData_employeeID] = useState<string | null>(null);
    let [schema, setData_schema] = useState<string | null>(null);
    let [isAuth, setData_isAuth] = useState<string | null>(null);
    let [access, setData_accessRights] = useState<string | null>(null);*/

    let acctID = '' || null;
    let employeeID = '' || null;
    let schema = '' || null;
    let isAuth = '' || null;
    let access = '' || [];

    //alert("IN APP MAIN");
    //alert(authenticatedMerchent_context.authenticated);

    useEffect(() => {
        
        NativeBiometric.isAvailable().then(
            (result) => {
                
            const isAvailable = result.isAvailable;
            const isAvailable_isFingerPrint = result.biometryType == BiometryType.FINGERPRINT;
            //const isFaceId = result.biometryType == BiometryType.FACE_ID;

            //alert(isAvailable);

                if(isAvailable == true) 
                {
                    //alert("is isAvailable = true")

                    setAppDevice_url(window.location.origin+"/");
                    authenticatedMerchent_context.changeBaseURL(window.location.origin+"/");
                    setAppDevice_device('mobile');



                }
                else if (isAvailable == false) 
                {
                    //alert("is isAvailable = false")
                    //alert(window.location);

                    setAppDevice_url(window.location.origin+"/");
                    authenticatedMerchent_context.changeBaseURL(window.location.origin+"/");
                    setAppDevice_device('desktop');

                }

            },            
            (error) =>
            {
                //alert("FINGERPRINT not available");
                //alert(window.location);

                setAppDevice_url(window.location.origin+"/");
                setAppDevice_device('desktop');
                authenticatedMerchent_context.changeBaseURL(window.location.origin+"/");

            }
            )

        }, [])


    useEffect(() => {

        //alert('in use effect');
        //alert(window.location.origin+"/");
        //alert(window.location.pathname);
        //alert(authenticatedMerchent_context.authenticated);

        if(window.location.pathname.includes('offer_letter'))
        {

             //alert( window.location.href);
            // alert( window.location.pathname);
            // alert( window.location.url);

            let cols = window.location.href.split('#');

            setAppliant_merchantID(cols[1]);
            setAppliant_requisitionID(cols[2]);
            setAppliant_applicationID(cols[3]);
            setViewApplicant_OfferModal(true);
            

            history.push('/offer_letter#'+cols[1]+'#'+cols[2]+'#'+cols[3]);

        }
        else if (window.location.pathname != '/privacy_statement' && window.location.pathname != '/contact' && window.location.pathname != '/home' && window.location.pathname != '/zasava_profileSetting' && window.location.pathname != '/zasava_accountSetting' && window.location.pathname != '/logout') 
        {
            //alert("inside 1");
            
            history.push('/');
        }


     }, []);

     useEffect(() => {

        if(notificationData != null)
        {
            alert(notificationData);

            setNotificationData(null);
        }
        

     }, [notificationData])

     //alert(authenticatedMerchent_context.authenticated);
     //alert(window.location.pathname);

    return (<IonApp>    
            <IonPage >        


                {(authenticatedMerchent_context.authenticated == 'T0' && window.location.pathname != '/logout') ?
                    ( 
                        <React.Fragment>
                        <IonSplitPane when="(min-width: 992px)" contentId='qavaAppConfirmed'>

                            <SideMenu disabled={false} contentId="qavaAppConfirmed" type="overlay"/>   

                            <Push_Notification notificationData={(e) => setNotificationData(e)}></Push_Notification>

                            <IonRouterOutlet id='qavaAppConfirmed'>
                                <PrivateRoute_Zasava path="/"> <HomePage_Admin /></PrivateRoute_Zasava>
                                <PrivateRoute_Zasava path="/admin_zsava_indexApp"> <HomePage_Admin /></PrivateRoute_Zasava>
                                <PrivateRoute_Zasava path="/zasava_profileSetting"> <Zasava_ProfileSetting /></PrivateRoute_Zasava>
                                <PrivateRoute_Zasava path="/zasava_accountSetting"> <Zasava_AccountSetting /></PrivateRoute_Zasava>
                                <PrivateRoute_Zasava path="/home"> <ZsavaHome /></PrivateRoute_Zasava>
                            </IonRouterOutlet>

                        </IonSplitPane>
                        </React.Fragment>) : (null) }
                
                
                {(authenticatedMerchent_context.loginUsername != null && (cookies.get('session') == null || cookies.get('session') == undefined)) && <ZasavaLoginCredentials openModal={ merchantLoginModal } closeModal={() => setMerchantLoginModal(false)}></ZasavaLoginCredentials>}

                {(authenticatedMerchent_context.authenticated != null && window.location.pathname == '/logout') && <ConfirmMerchantLogout ></ConfirmMerchantLogout>}

                {(viewApplicant_OfferModal == true && authenticatedMerchent_context.authenticated == null && window.location.pathname.includes('offer_letter')) && <Applicant_OfferLetterModal openModal={ viewApplicant_OfferModal } closeModal={() => setViewApplicant_OfferModal(false)} data={{
                    applicant_merchant_accountID: applicant_merchantID,
                    applicant_requisitionID: applicant_requisitionID,
                    applicant_applicationID: applicant_applicationID,
                    status: 'user_applicant_offer',
                                        }}></Applicant_OfferLetterModal>}

                {authenticatedMerchent_context.authenticated == null &&
                (
                    <React.Fragment>
                        <IonRouterOutlet >
                                    <Route exact path="/home" render={() => <ZsavaHome />}/> 
                                    <Route exact path="/privacy_statement" render={() => <Zasava_PrivacyStatement />}/> 
                                    <Route exact path="/contact" render={() => <Contact_Us />}/> 
                                    <Route exact path="/" render={() => <ZsavaHome   />} />
                        </IonRouterOutlet>
                    </React.Fragment>)
                }
            </IonPage>  
            </IonApp>
        )
}

//Notes

export default App;




